export default __webpack_public_path__ + "static/media/icon-012.4b17b142.svg";